<template>

  <HeaderYachts :section="section" />

  <div class="container py-5">

    <h1 class="text-center mb-5">
      {{ pageItem.title }}
    </h1>

    <div class="my-5" v-html="pageItem.introtext"></div>

    <div v-if="pageSlider" class="text-center my-5">
      <div id="carousel" class="carousel slide carousel-fade">
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#carousel" v-for="(slider, index) in pageSlider" :key="index" :class="(sliderIndex == index) ? 'active' : ''" @click="setIndex(index)"></button>
        </div>
        <div id="carousel-inner" class="carousel-inner">
          <div class="ratio ratio-16x9">
            <div v-for="(slider, index) in pageSlider" :key="index" :id="slider.type +'-'+ index" :class="['carousel-item', ((sliderIndex == index) ? 'active' : '')]">
              <img v-if="slider.type == 'image'" :src="slider.src" class="d-block img-fluid mx-auto" :alt="slider.caption">
              <video v-if="slider.type == 'video'" class="d-block w-100" playsinline controls loop>
                <source :src="slider.src" type="video/mp4">
              </video>
              <div class="carousel-caption d-none d-md-block">
                <h5>{{ slider.caption }}</h5>
                <!-- <p>{{ slider.caption }}</p> -->
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button> -->
      </div>
    </div>

  </div>

  <div v-if="pageItem.text1 || pageItem.image1" class="py-4"></div>

  <div v-if="pageItem.text1" class="container my-5" v-html="pageItem.text1"></div>

  <div v-if="pageItem.image1" class="my-5 text-center">
    <img :src="pageItem.image1" class="img-fluid" alt=" ">
  </div>
  
  <div v-if="pageItem.text2 || pageItem.image2" class="py-4"></div>

  <div v-if="pageItem.text2" class="container my-5" v-html="pageItem.text2"></div>

  <div v-if="pageItem.image2" class="my-5 text-center">
    <img :src="pageItem.image2" class="img-fluid" alt=" ">
  </div>
  
  <CompanyDocuments v-if="pageItem.documents" :pageItem="pageItem" />

</template>

<script>
  import HeaderYachts from './headers/HeaderYachts.vue'
  import CompanyDocuments from './CompanyDocuments.vue'

  export default {
    name: 'CompanyPage',
    data() {
      return {
        section: this.$store.getters.section,
        pageItems: this.$store.getters['filelist/pageItems'],
        sliderIndex: 0,
        videoActive: null,
      }
    },
    computed: {
      pageItem() {
        if (!this.pageItems) return false
        return this.$store.getters['filelist/pagesFromSection'](this.section)
      },
      pageSlider() {
        if (!this.pageItem) return false
        return this.pageItem.slider
      },
    },
    methods: {
      setIndex(index) {
        this.sliderIndex = index
        setTimeout(() => {
          this.checkAutoplay()
        }, 500); 
      },
			async playVideo() {
        try {
          console.log('> avvio active video')
          //this.videoActive.setAttribute('autoplay', 'true')
          await this.videoActive.play()
        } catch(err) {
          console.log(err)
        }
      },
			checkAutoplay() {
        console.log('*** checkAutoplay ***')
				let carousel = document.getElementById('carousel-inner')
        if (!carousel) return
        if (this.videoActive) {
          console.log('+ pauso active video')
          this.videoActive.pause()
          this.videoActive.currentTime = 0
          this.videoActive = null
        }
				let itemActive = carousel.getElementsByClassName('active')
        console.log('itemActive length', itemActive.length)
        console.log('itemActive', itemActive[0].id)
        let video = itemActive[0].getElementsByTagName('video')
        if (video.length) {
          if (video[0]) {
            this.videoActive = video[0]
            this.playVideo()
          }
        } else {
          console.log('X non è un video')
        }
			},
    },
    created() {
      document.body.classList.remove('yacht-page')
    },
    mounted() {
        setTimeout(() => {
          this.checkAutoplay()
        }, 500); 
    },
    components: {
      HeaderYachts,
      CompanyDocuments
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .carousel-indicators {
    bottom: -40px;
  }
  .carousel-inner img {
    max-height: 100%;
  }
</style>
